import React, { useEffect } from "react";
// import '../css/priv-pol.css';

const CSAE = () => {
  useEffect(() => {
    document.title =
      "SearchMe - Standards Against Child Sexual Abuse and Exploitation";
  }, []);

  const textLeft = {
    textAlign: "left",
  };

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 px-md-5 flex-column">
      <header className="mb-3">
        <img
          src="../logo/Logo.png"
          alt="SearchMe"
          width={55}
          height={55}
          className="justify-content-center mb-0"
        />
      </header>
      <h3 style={textLeft}>
        Standards Against Child Sexual Abuse and Exploitation (CSAE) Commitment
        to Protecting Children
      </h3>
      {/* <p style={textLeft}>Last updated: January 18, 2025</p> */}
      <p style={textLeft}>
        We are committed to safeguarding children from all forms of sexual abuse
        and exploitation. Our app upholds the highest standards of safety and
        accountability to ensure a secure environment for all users, especially
        minors.
      </p>

      <h4 style={textLeft}>Policy Overview</h4>
      <h5 style={textLeft}>
        Our standards against Child Sexual Abuse and Exploitation (CSAE)
        encompass the following key areas:
      </h5>

      <h6 style={textLeft}>Zero Tolerance Policy:</h6>
      <p style={textLeft}>
        We enforce a strict zero-tolerance policy against any content or
        behavior that promotes, depicts, or facilitates CSAE.
      </p>

      <h6 style={textLeft}>Content Monitoring and Reporting:</h6>
      <p style={textLeft}>
        Our app actively monitors content to prevent the sharing of illegal or
        harmful materials. Users can report suspicious content or behavior, and
        such reports are reviewed promptly.
      </p>

      <h6 style={textLeft}>Partnerships with Law Enforcement:</h6>
      <p style={textLeft}>
        We collaborate with law enforcement agencies to report any CSAE-related
        incidents and ensure swift legal action.
      </p>

      <h6 style={textLeft}>Age Verification and Parental Controls:</h6>
      <p style={textLeft}>
        Robust age verification measures are in place to prevent unauthorized
        access by minors. Parental controls empower guardians to supervise and
        restrict app usage.
      </p>

      <h6 style={textLeft}>User Education:</h6>
      <p style={textLeft}>
        We educate users on safe online practices and the importance of
        reporting inappropriate content.
      </p>

      <h6 style={textLeft}>Data Privacy and Protection:</h6>
      <p style={textLeft}>
        Personal data is protected following stringent privacy laws, minimizing
        risks to children.
      </p>

      <h6 style={textLeft}>Employee Training:</h6>
      <p style={textLeft}>
        Our team is trained to identify and respond to CSAE concerns, ensuring
        swift and effective action.
      </p>

      <h6 style={textLeft}>Regular Policy Review:</h6>
      <p style={textLeft}>
        This policy is reviewed regularly to ensure compliance with evolving
        legal standards and best practices.
      </p>

      <h6 style={textLeft}>
        Reporting and Support If you encounter any CSAE-related content or
        behavior on our platform:
      </h6>
      <p style={textLeft}>
        Report it immediately using the in-app reporting tool. If necessary,
        report directly to law enforcement in your region.
      </p>

      <h6 style={textLeft}>Collaboration for a Safer Internet:</h6>
      <p style={textLeft}>
        We encourage users, organizations, and communities to work together in
        combating CSAE. By staying vigilant and proactive, we can create a safer
        online environment for everyone.
      </p>

      <h6 style={textLeft}>
        For further information or inquiries, please contact us at
        findme.mobileapplication@gmail.com.
      </h6>

      <footer className="mt-auto h1-search">
        <p style={textLeft} className="text-center">
          &copy; SearchMe 2025
        </p>
      </footer>
    </div>
  );
};

export default CSAE;
